export const REFERRAL_TIERS = [
  { count: 1, label: 'HXD Ceramic Mug', icon: '☕' },
  { count: 3, label: 'HXD Tote Bag', icon: '🎒' },
  { count: 5, label: '1-Month Premium Upgrade', icon: '⭐' },
  { count: 10, label: 'HXD Flight Jacket', icon: '🧥' },
  { count: 25, label: 'Founding Member Plaque', icon: '🏆' },
];
